import React from 'react';
import SearchBarSkeleton from './SearchBarSkeleton';
import DirectoryLettersSkeleton from './DirectoryLettersSkeleton';
import OrgDirectoryGridSkeleton from './OrgDirectoryGridSkeleton';

interface OrgDirectorySkeletonProps {
  count?: number;
}

const OrgDirectorySkeleton: React.FC<OrgDirectorySkeletonProps> = ({ 
  count = 12 
}) => {
  return (
    <div className="w-full px-4 md:px-8 md:mx-auto md:max-w-[1200px]">
      {/* Count skeleton */}
      <div className="text-center md:text-left mb-6 text-xs font-normal tracking-[0px] animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-24" />
      </div>

      {/* Search bar skeleton */}
      <SearchBarSkeleton />

      {/* Directory letters skeleton */}
      <DirectoryLettersSkeleton />

      {/* Grid skeleton - matches exact real component structure */}
      <OrgDirectoryGridSkeleton count={count} />

      {/* Load More button area - matches real component */}
      <div className="text-center h-14 md:h-16 flex items-center justify-center px-4">
        <div className="px-4 md:px-6 py-2 md:py-3 h-8 md:h-9 w-full max-w-xs md:w-24 bg-gray-200 rounded-full animate-pulse" />
      </div>
    </div>
  );
};

export default OrgDirectorySkeleton;
